export default {    
    // 获取url后面的参数值
    urlget(ids){
         
      let geturl = window.location.href
      let getqyinfo = geturl.split('?')[1]
     
      let getqys = new URLSearchParams(getqyinfo) //将参数放在URLSearchParams函数中
      
      return getqys.get(ids)
    }
             
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js